import { useQuery } from '@hooks/reactQuery';

import { assetProfileOutgoingRequests } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAssetProfileOutgoingRequests } from '@api/assetProfileOutgoingRequests';

import { endOfDayInUTC, startOfDayInUTC } from '@utils/kpi-utils/date';

import { ASSET_PROFILE_OUTGOING_REQUESTS } from '@constants/queryKeys';

export const useQueryAssetProfileOutgoingRequests = (assetDbId?: string) => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		startRentDate,
		endRentDate,
	} = useAppSelector(assetProfileOutgoingRequests);

	const {
		data,
		isLoading: isLoadingOutgoingRequests,
		isFetching: isFetchingOutgoingRequests,
	} = useQuery({
		queryKey: [
			ASSET_PROFILE_OUTGOING_REQUESTS,
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
			startRentDate,
			endRentDate,
		],
		queryFn: () => getAssetProfileOutgoingRequests({
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
			assetDbId,
			requestedStartDate: startRentDate && startOfDayInUTC(new Date(startRentDate)),
			requestedEndDate: endRentDate && endOfDayInUTC(new Date(endRentDate)),
		}),
		enabled: [!!assetDbId],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingOutgoingRequests: isLoadingOutgoingRequests || isFetchingOutgoingRequests,
		outgoingRequests: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
